import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button, SparkIcon } from '@spark';
import './DocsSidebar.css';

const docsMenuItems = [
    {
        key: 'installation',
        label: 'Installation',
        iconSlug: 'download',
    },
    {
        key: 'external-deploy',
        label: 'External Deploy',
        iconSlug: 'rocket',
    },
    {
        key: 'querying',
        label: 'Querying',
        iconSlug: 'code',
    },
    {
        key: 'logging',
        label: 'Logging',
        iconSlug: 'description',
    },
    {
        key: 'support-doc',
        label: 'Support',
        iconSlug: 'circle-help',
    },
];

const DocsSidebar = ({ currentUsecaseId }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const currentPath = location.pathname.slice(1);
    const isDocsPage = docsMenuItems.some((item) => item.key === currentPath);

    if (!isDocsPage) {
        return null;
    }

    const handleClick = (key) => {
        const path = `/${key}`;
        const url = currentUsecaseId ? `${path}?usecaseId=${currentUsecaseId}` : path;
        navigate(url);
    };

    return (
        <div className="docs-sidebar-container">
            <div className="docs-sidebar-header">Documentation</div>
            <nav className="docs-sidebar-nav">
                {docsMenuItems.map((item) => (
                    <Button
                        key={item.key}
                        variant="text"
                        size="medium"
                        fill
                        className={`docs-sidebar-item${currentPath === item.key ? ' docs-sidebar-item--active' : ''}`}
                        startIcon={<SparkIcon slug={item.iconSlug} size="small" />}
                        onClick={() => handleClick(item.key)}
                        aria-current={currentPath === item.key ? 'page' : undefined}
                    >
                        {item.label}
                    </Button>
                ))}
            </nav>
        </div>
    );
};

export default DocsSidebar;
